/**
 * Real customer testimonials — iter 141
 *
 * PLUG-AND-PLAY DATA SOURCE for the homepage <RealTestimonials /> block.
 *
 * ⚠️  DO NOT populate this file until you have written permission from
 *    the customer to use their name and quote. Screenshotted DMs, email
 *    threads, or a filled testimonials-consent.md log all count as
 *    written permission — save the artifact somewhere retrievable so
 *    counsel can trace consent later.
 *
 * When you have a quote:
 *   1. Add an entry to the array below with { name, role, company, quote,
 *      avatar_url?, consent_ref } — consent_ref is the filename or link
 *      to the permission artifact.
 *   2. The homepage <RealTestimonials /> component will start rendering
 *      the block automatically on the next page load (no code changes).
 *   3. Do not use stock photos as fake customers. If you don't have an
 *      avatar, leave avatar_url blank — the component draws initials.
 *
 * Empty array = nothing rendered on the homepage. Safe default.
 */

export const realTestimonials = [
    // Example schema — DO NOT UNCOMMENT WITHOUT REAL, DOCUMENTED CONSENT:
    // {
    //     name: "Jane Doe",
    //     role: "Head of Talent",
    //     company: "Real Company Inc.",
    //     quote: "Simonara let us skip a week of resume-shuffling and just meet three verified people we could hire.",
    //     avatar_url: "",         // optional
    //     consent_ref: "consents/2026-02-jane-doe.png",
    // },
];
